import { useSearchParams } from "react-router-dom";
import AllergyCategoryService from "../../../services/AllergyCategoryService";
import { useEffect, useState } from "react";
import { AllergyCategory } from "../../../models";
import Breadcrumbs from "../../../components/breadcrumbs";
 
import AllergyCategoriesTable from "./ui/allergy-categories-table";
import AllergyCategoriesTableSkeleton from "./skeletons/allergy-categories-table-skeleton";
import toast from "react-hot-toast";
import { CreateButton } from "./ui/buttons";

export default function AllergyCategoriesPage(){
    const [searchParams] = useSearchParams();
      const api = new AllergyCategoryService();
      const [items, setItems] = useState<AllergyCategory[]>([]);
      const [loading, setLoading] = useState(true);
    
      useEffect(() => {
        fetchData();
      }, [searchParams.get("reload")]);
    
      const fetchData = async () => {
        try{
        const data = await api.getAllergyCategories();
        setItems(data);
    }
    catch(e){
        console.log(e);
        toast.error("Data load error");
    }
    setLoading(false);
      };
    
      return (
        <div className="w-full">
             <Breadcrumbs
                        breadcrumbs={[
                          { label: "Allergy Categories", href: "/admin/allergy-categories" },                      
                        ]}
                      />
          
          <CreateButton />
          {loading ? (
            <AllergyCategoriesTableSkeleton />
          ) : (
            <AllergyCategoriesTable categories={items} />
          )}
        </div>
      );
    }
